var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:{
    'is-selected': _vm.selected,
    'is-light': _vm.light,
    'is-clickable': _vm.clickable,
  }},[_c('div',{staticClass:"tag__label",domProps:{"innerHTML":_vm._s(_vm.label)}}),(_vm.type === 'add')?_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"tag__icon",attrs:{"size":"0 0 14 18","symbol":"ui-plus"}}):_vm._e(),(_vm.type === 'remove')?_c('svg',{directives:[{name:"svg",rawName:"v-svg"}],staticClass:"tag__icon",attrs:{"size":"0 0 14 18","symbol":"ui-cross"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }